var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseInfoButton',{attrs:{"identifier":_vm.panel.id,"viewmodel":_vm.panel},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var url = ref.url;
return [_c('a',{staticClass:"anchor",style:(_vm.anchorStyles),attrs:{"href":_vm.anchorLink,"title":"Right click to copy link"}}),_vm._v(" "),_c('a',{attrs:{"href":url,"target":"_blank"}},[_vm._v("Panel")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }